import { credentials } from './gmb_api';
import { useEffect }   from 'react';
import rollbar         from '../../rollbar';


// https://github.com/EddyVerbruggen/cordova-plugin-googleplus

export default function GoogleAuthCordova({ state, updateState, requireReauthorization }) {

  useEffect(() => {
    if (state.client)
      return () => {};

    const googlePlus = typeof window !== 'undefined' && window.plugins?.googleplus;

    if (!googlePlus) {
      rollbar.error(new Error('GooglePlus is undefined'), window.plugins);
      updateState({ error: true });
      return () => {};
    }

    const options = {
      webApiKey:   credentials.apiKey,
      webClientId: credentials.clientID,
      scopes:      credentials.scope,
      offline:     requireReauthorization
    };

    function getResponseState(response) {
      const { accessToken } = response;
      const isSignedIn      = !!accessToken;
      return {
        accessToken,
        isSignedIn
      };
    }

    function setIsSignedIn(response) {
      const responseState = getResponseState(response);
      updateState(responseState);
    }

    const client = {
      signIn() {
        googlePlus.login(
          options,
          setIsSignedIn,
          () => {
            updateState({
              accessToken: null,
              isSignedIn:  false
            });
          }
        );
      },
      signOut() {
        return new Promise((resolve, reject) => {
          googlePlus.logout(
            () => {
              updateState({
                accessToken: null,
                isSignedIn:  false
              });
              resolve();
            },
            error => {
              reject(error);
            }
          );
        });
      },
      grantOfflineAccess() {
        return new Promise((resolve, reject) => {
          googlePlus.login(
            options,
            response => {
              setIsSignedIn(response);
              const { serverAuthCode } = response;
              resolve({ code: serverAuthCode });
            },
            error => {
              reject(error);
            }
          );
        });
      }
    };

    (async() => {
      if (requireReauthorization) {
        try {
          await client.signOut();
        } catch (error) {
          // if we call signOut before being signed in
          // the plugin throws an error.
        }
      }

      googlePlus.trySilentLogin(
        options,
        response => {
          const responseState = getResponseState(response);
          updateState({
            ...responseState,
            client
          });
        },
        () => {
          updateState({
            isSignedIn: false,
            client
          });
        }
      );
    })();

    return () => {};
  }, [ requireReauthorization, state.client, updateState ]);

  return null;
}
